<template>
  <nav>
    <ul
      v-if="$route.name !== 'banned'"
      class="navigation container d-flex justify-content-between"
    >
      <li class="nav__logo">
        <Logo class="nav__link nav__link--logo" />
      </li>
      <li class="mr-auto">
        <ul class="d-flex">
          <li class="nav__item">
            <router-link class="nav__link primary" to="/dashboard">
              {{ $t("Home") }}
            </router-link>
          </li>
          <li class="nav__item">
            <router-link to="/actions" class="nav__link primary">
              {{ $t("Missioni") }}
            </router-link>
          </li>
          <li class="nav__item">
            <router-link to="/catalog" class="nav__link primary">
              {{ $t("Catalogo") }}
            </router-link>
          </li>
          <li class="nav__item">
            <router-link to="/leaderboard" class="nav__link primary">
              {{ $t("Classifica") }}
            </router-link>
          </li>
          <li class="nav__item">
            <router-link to="/settings/profile" class="nav__link primary">
              {{ $t("Profilo") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li class="justify-self-end box mr-3">
        <ul class="d-flex">
          <!-- <li class="nav__item">
            <router-link to="/" class="nav__link">
              Come funziona
            </router-link>
          </li>
          <li class="nav__item">
            <router-link to="/" class="nav__link">
              FAQ
            </router-link>
          </li> -->
        </ul>
      </li>
      <li
        class="justify-self-end box"
        v-if="this.$store.state.campaign.accept_languages.length > 1"
      >
        <ul class="d-flex">
          <li class="nav__item">
            <LocaleChanger></LocaleChanger>
          </li>
        </ul>
      </li>
    </ul>

    <template v-if="$route.name == 'banned'">
      <nav
        class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap"
        id="bottomBar"
      >
        <router-link to="/dashboard" class="nav-item nav-link">
          <i class="fal fa-home"></i>
          {{ $t("Home") }}
        </router-link>
        <router-link to="/leaderboard" class="nav-item nav-link">
          <i class="fal fa-chart-bar"></i>
          {{ $t("Classifica") }}
        </router-link>
        <router-link to="/catalog" class="nav-item nav-link">
          <i class="fal fa-tags"></i>
          {{ $t("Catalogo") }}
        </router-link>
        <router-link to="/code" class="nav-item nav-link">
          <i class="fal fa-qrcode"></i>
          {{ $t("Inserisci codice") }}
        </router-link>

        <router-link
          v-if="$store.state.campaign.mgm_enabled"
          to="/invite"
          class="nav-item nav-link"
        >
          <div v-html="iconMgm" style="line-height:1px;"></div>
          {{ $t("Invita") }}
        </router-link>
      </nav>
    </template>
    <template v-else>
      <nav
        class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap"
        id="bottomBar"
      >
        <li class="nav-item">
          <a class="nav-link">
            <div
              v-html="iconLogout"
              @click="
                $store.dispatch('logout');
                $router.push('/');
              "
              class="ml-4 f-icon"
              style="line-height:1px;width:30px;cursor: pointer"
            ></div>
          </a>
        </li>
      </nav>
    </template>
  </nav>
</template>

<script>
import iconLogout from "@/assets/svg/fnz_logout.svg";
import iconMgm from "@/assets/svg/fnz_mgm.svg";
import Logo from "./Logo";
import LocaleChanger from "@/components/rebuild/common/LocaleChanger";
export default {
  name: "navigation",
  data: function() {
    return {
      iconLogout: iconLogout,
      iconMgm: iconMgm
    };
  },
  components: {
    Logo,
    LocaleChanger
  },
  computed: {
    logoImage() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        this.$store.getters.getBrandLogo
      );
    }
  },
  created() {
    window.prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
      let currentScrollPos = window.pageYOffset;
      const navbarScrollable = document.getElementById("navbar-scrollable");
      if (window.prevScrollpos > currentScrollPos && navbarScrollable) {
        navbarScrollable.classList.remove("scroll");
      } else if (navbarScrollable && currentScrollPos > 0) {
        navbarScrollable.classList.add("scroll");
      }
      window.prevScrollpos = currentScrollPos;
    };
  }
};
</script>
<style lang="scss" scoped>
.navigation {
  padding-top: 15px;
  align-items: center;
  color: #000000;
}
.nav__logo {
  min-width: 93px;
  max-width: 93px;

  @media (min-width: 992px) {
    margin-right: 50px;
  }
}

.logo {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.nav__link {
  padding: 0 15px;
}

.nav__link--logo {
  text-decoration: none;
  padding: 0;
}
.box {
  .nav__item:last-of-type .nav__link {
    padding-right: 0;
  }
}

.router-link-active {
  font-weight: 900;
}
</style>
